import { faHeart } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { useSnapshot } from 'valtio';
import { authStore } from '../../../store/authStore';
import { modalActions } from '../../../store/authStore/modalStore';
import { Button } from '../../components/button';
import { Alert, EmptyState, LoadingBlock, PageContainer, PageHeader } from '../../components/ui';
import { useMyWishlistQuery } from '../../services/stayService/__generated__/queries.generated';
import { StayCard, StayGrid } from './StayGuestComponents';

/** Places the guest saved (spec 016 W15). Favorites are shared with cars; only places show here. */
export default function WishlistsPage() {
  const navigate = useNavigate();
  const { isAuthenticated } = useSnapshot(authStore);
  const { data, loading, error } = useMyWishlistQuery({
    skip: !isAuthenticated,
    fetchPolicy: 'cache-and-network',
  });
  const places = (data?.getMyFavorites ?? []).filter(listing => listing.stayDetails);

  return (
    <PageContainer width="xl">
      <PageHeader title="Wishlists" />
      {!isAuthenticated ? (
        <EmptyState
          icon={faHeart}
          title="Log in to see your wishlists"
          description="Save places you like with the heart, and find them here."
          action={
            <Button type="button" text="Log in" onClick={() => modalActions.openSignInModal()} />
          }
        />
      ) : error && !data ? (
        <Alert tone="error" title="Could not load your wishlist">
          Try again in a moment.
        </Alert>
      ) : loading && !data ? (
        <LoadingBlock label="Loading your wishlist" />
      ) : places.length === 0 ? (
        <EmptyState
          icon={faHeart}
          title="Create your first wishlist"
          description="As you search, tap the heart to save places you like."
          action={
            <Button
              type="button"
              theme="secondary"
              text="Start searching"
              onClick={() => navigate('/')}
            />
          }
        />
      ) : (
        <StayGrid data-testid="stay-wishlist">
          {places.map(listing => (
            <StayCard
              key={listing.id}
              listing={listing}
              onOpen={() => navigate(`/stays/${listing.id}`)}
            />
          ))}
        </StayGrid>
      )}
    </PageContainer>
  );
}
